import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

import { type PlacementWithDetails } from "../api/useFetchPaginatedPlacements";
import { AlternativeAddressInfo } from "./AlternativeAddressInfo";
import { type AlternativeAddressData } from "./PlacementDetailsPage/hooks/useAlternativeAddress";

interface AlternativeAddressModalProps {
  modalState: UseModalState;
  placementDetails: PlacementWithDetails;
  alternativeAddressData: AlternativeAddressData;
  onContinue: () => void;
}

export function AlternativeAddressModal(props: AlternativeAddressModalProps) {
  const { modalState, placementDetails, alternativeAddressData, onContinue } = props;
  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter
          orientation="vertical"
          onClose={() => {
            modalState.closeModal();
          }}
        >
          <Button fullWidth variant="contained" size="large" onClick={onContinue}>
            OK, let’s book the interview
          </Button>
        </DialogFooter>
      }
    >
      <Stack sx={{ p: 8 }}>
        <AlternativeAddressInfo
          placementDetails={placementDetails}
          alternativeAddressData={alternativeAddressData}
        />
      </Stack>
    </BottomSheet>
  );
}
